import { useRoutes } from "react-router-dom";
// import ReactGA from 'react-ga';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { SnackbarProvider } from "notistack";
import { useAuth0 } from "@auth0/auth0-react";
import { CssBaseline } from "@mui/material";
import { useEffect } from "react";
// import { useCookies } from 'react-cookie';

// todo: don't delete needed in future
// import jwt_decode from 'jwt-decode';
import { useDispatch, useSelector } from "react-redux";
import { createSession, deleteSession, getUser } from "./slices/user";
import ThemeProvider from "./theme/ThemeProvider";
import tscCuRoutes from "src/router/TscCuRoutes/TscCuRouter";
import adminRoutes from "src/router/AdminRoutes/AdminRouter";
import vendorRoutes from "src/router/VendorRouters/VendorRouter";
import publicRoutes from "src/router/public/index";
import AppInit from "./components/AppInit";
import jwt_decode from "jwt-decode";
import CommonLoader from "src/components/_shared/CommonLoader/CommonLoader";
import { useAppContext } from "./utils/AppContextUtils";
import { isValidJwtFormat } from "./utils/CommonUtils";
import { fetchPermissions } from "./slices/permission";
import filterRoutesByRole from "./utils/filterRoute";
import { usePermission } from "./utils/PermissionProvider";
import useAccessTokenUpdater from "./utils/useAccessTokenUpdater";
import useLocalStorageListener from "./hooks/useLocalStorageListener";
// import * as analytics from './utils/ga4';

// this key should move to env file
// ReactGA.initialize('UA-292259291-1');

//log
function App() {
  const dispatch = useDispatch();
  let content = null;
  const { user, isAuthenticated, logout, getAccessTokenSilently } = useAuth0();
  const { fetchPermissionsData, data } = usePermission();
  const { users } = useSelector((state: any) => state.user);
  const { stateValue } = useAppContext();
  useLocalStorageListener("sessionStorage");

  // const [cookies] = useCookies(['cookieConsent']);
  // let location = useLocation();

  // useEffect(() => {
  //   if (cookies.cookieConsent === 'accept_all_cookies') {
  //     // ReactGA.initialize('G-44V6XKLEQ0');
  //     // ReactGA.set({ page: location.pathname });
  //     // ReactGA.pageview(window.location.pathname + window.location.search);
  //     analytics.init();
  //     const path = location.pathname + location.search;
  //     analytics.sendPageview(path);
  //   }
  // }, [location]);

  const checkTokenExpiry = () => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      // Token is not available, perform logout
      // logout();
      return;
    }
    if (!isValidJwtFormat(token)) {
      localStorage.clear();
      window.location.reload();
    }

    const decodedToken: any = jwt_decode(token);
    const expiryTime = decodedToken?.exp;
    const currentTimestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds
    const remainingTime = expiryTime - currentTimestamp;

    if (remainingTime <= 10) {
      // Token has expired, perform logout
      localStorage.clear();
    } else {
      // Set a timer to automatically logout when the token expires
      // const timeout = setTimeout(logout, remainingTime * 1000); // Convert seconds to milliseconds
      // // Clear the timer when the component unmounts or when token changes
      // return () => clearTimeout(timeout);
    }
  };

  const handleLogout = async (): Promise<void> => {
    const sessionStorage = JSON.parse(localStorage.getItem("sessionStorage"));
    try {
      const sessionIds = {
        session_id: sessionStorage?._id,
      };
      let res = await dispatch<any>(deleteSession({ sessionIds: sessionIds }));
      if (res?.error) {
        return;
      } else {
        logout({
          logoutParams: {
            returnTo: process.env.REACT_APP_AUTH0_LOGOUT_REDIRECT_URI,
          },
        });
        localStorage.clear();
      }
    } catch (err) {
      return err;
    }
  };


  const initialAppCall = (fromEvent: any) => {
    if(fromEvent?.key && (fromEvent?.key !== 'loggedUserId' && fromEvent?.key !== 'userDetail')
     ){
      return;
    }
    // todo: don't delete needed in future
    checkTokenExpiry();

    // if (!user) { 
    //   localStorage.clear();
    // }
    if (localStorage.getItem("accessToken")) {
      // const token = localStorage.getItem('accessToken');
      // let decodedToken: any = jwt_decode(token);

      // let dateNow = new Date();

      // if (decodedToken.exp < dateNow.getTime()) {
      // }
      const token = localStorage.getItem("accessToken");
      const decodedToken: any = jwt_decode(token);
      const expirationTime = decodedToken.exp;

      // Compare current time with the token's expiration time
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds

      if (currentTime > expirationTime) {
        localStorage.clear();
        window.location.reload();
      }
    }
    if (!user && fromEvent === "user") {
      // localStorage.clear();
      return;
    }
    const initialCall = async () => {
      // const token = await getAccessTokenSilently();
      const accessToken = await getAccessTokenSilently();
      const decodedToken: any = jwt_decode(accessToken);
      if (!accessToken) {
        return;
      }
      const storedToken = localStorage.getItem("accessToken");
      if(!storedToken){
        localStorage.setItem("accessToken", accessToken);
      }
      await dispatch<any>(createSession({ token: storedToken ? accessToken : "" }));
      if(storedToken){
        localStorage.setItem("accessToken", accessToken);
      }
      const userId = decodedToken.sub.split("|")[1];
      localStorage.setItem("loggedUserId", userId);
      // await dispatch<any>(fetchPermissions());
      await fetchPermissionsData();
      await dispatch<any>(getUser({ userId: userId }));

      // const token = accessToken;
      // if (token) {
      //   const expiryTime = decodedToken?.exp;
      //   const checkExpiry = setInterval(() => {
      //     const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      //     const timeDifference = expiryTime - currentTime;
      //     if (timeDifference < 300) {
      //       // 5 minutes = 300 seconds
      //       // Log out user
      //       handleLogout();
      //       clearInterval(checkExpiry); // Stop the interval
      //     }
      //   }, 1000); // Check every second

      //   return () => clearInterval(checkExpiry);
      // }
    };

    initialCall();
  }

  useEffect(() => {
    initialAppCall("user")  
  }, [user]);

  useEffect(() => {
    window.addEventListener("storage", initialAppCall);
    return () => {
      window.removeEventListener("storage", initialAppCall);
    };
  }, []);


  // todo: don't delete needed in future

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }
  // const gaRoute = useRoutes(adminRoutes);
  // const cuRoute = useRoutes(tscCuRoutes);
  // const lsRoute = useRoutes(vendorRoutes);
  // const publicRoute = useRoutes(publicRoutes);

  let routes;
  if (
    isAuthenticated ||
    (localStorage.getItem("accessToken") &&
      localStorage.getItem("loggedUserId"))
  ) {
    if (user && users) {
      if (users && users?.detail.user_type === "VENDOR") {
        const filterVenderRoute = filterRoutesByRole(
          vendorRoutes,
          users?.detail.role
        );
        content = useRoutes(filterVenderRoute);
      } else if (users && users?.detail.user_type === "CORPORATE") {
        const filterTSCRoute = filterRoutesByRole(
          tscCuRoutes,
          users?.detail.role
        );
        content = useRoutes(filterTSCRoute);
      }
    }
  } else {
    content = useRoutes(publicRoutes);
  }
  useAccessTokenUpdater(getAccessTokenSilently);
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider
          maxSnack={6}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <CommonLoader
            isLoading={stateValue?.isLoading}
            loadWithText={stateValue?.loadWithText}
          />
          <CssBaseline />
          {content ? content : <AppInit />}
          {/* {user ?  users?.detail.role ==="LS"? lsRoute :  users?.detail.role ==="CU"? cuRoute : users?.detail.role ==="GA" ? gaRoute : <AppInit /> : publicRoute } */}
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
